<template>
    <el-form :model="rule" :rules="rules" ref="forms" class="demo-ruleForm" label-width="120px">
        <el-form-item label="型号" prop="termVersion">
            <el-input placeholder="请输入型号" v-model="rule.termVersion" clearable></el-input>
        </el-form-item>
        <el-form-item label="中文名" prop="name">
            <el-input placeholder="请输入中文名" v-model="rule.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="能力" prop="abilitys">
            <el-checkbox-group v-model="checkList" @change="check">
                <el-checkbox v-for="x in rolesCheck" :key="x.id" :label="x.type">{{x.name}}</el-checkbox>
              </el-checkbox-group>
        </el-form-item>
        <el-form-item label="采集周期" prop="collCyc">
            <el-input type="number" placeholder="请输入采集周期" v-model="rule.collCyc" clearable></el-input>
        </el-form-item>
        <el-form-item label="上报周期" prop="rptCyc">
            <el-input type="number" placeholder="请输入上报周期" v-model="rule.rptCyc" clearable></el-input>
        </el-form-item>
        <el-form-item label="紧急采集周期" prop="emergencyCollCyc">
            <el-input type="number" placeholder="请输入紧急采集周期" v-model="rule.emergencyCollCyc" clearable></el-input>
        </el-form-item>
        <el-form-item label="紧急上报周期" prop="emergencyRptCyc">
            <el-input type="number" placeholder="请输入紧急上报周期" v-model="rule.emergencyRptCyc" clearable></el-input>
        </el-form-item>
        <el-form-item label="允许创建运单" prop="enableCreateTask">
            <el-switch
                v-model="rule.enableCreateTask"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#eeeeee">
            </el-switch>
        </el-form-item>
        <el-form-item label="允许开关机" prop="enableSwitchPower">
            <el-switch
                v-model="rule.enableSwitchPower"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#eeeeee">
            </el-switch>
        </el-form-item>
        <el-form-item label="安装方向" prop="installDirection">
            <el-select v-model="rule.installDirection">
                <el-option value="1" label="水平安装"></el-option>
                <el-option value="2" label="垂直安装"></el-option>
                <el-option value="3" label="横向安装"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="GPS开启状态" prop="enableGps">
            <el-switch
                v-model="rule.enableGps"
                active-value="1"
                inactive-value="0"
                active-color="#13ce66"
                inactive-color="#eeeeee">
            </el-switch>
        </el-form-item>
        <el-form-item label="工作开始时间" prop="workStartTime">
            <el-time-picker
                v-model="rule.workStartTime"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                placeholder="工作开始时间">
            </el-time-picker>
        </el-form-item>
        <el-form-item label="工作结束时间" prop="workEndTime">
            <el-time-picker
                v-model="rule.workEndTime"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                placeholder="工作结束时间">
            </el-time-picker>
        </el-form-item>
        <el-form-item label="低电上报周期" prop="lowElecRptCyc">
            <el-input type="number" placeholder="请输入低电上报周期" v-model="rule.lowElecRptCyc" clearable></el-input>
        </el-form-item>
        <el-form-item label="低电电压值" prop="lowElec">
            <el-input placeholder="请输入低电电压值" v-model="rule.lowElec" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="des">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入描述" v-model="rule.des" clearable></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">提交</el-button>
            <el-button @click="block">返回</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        data() {
            return {
                name: 'edit',
                checkList: [],
                rolesCheck:[],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rule: {
                    id: 0,
                    termVersion: '',
                    name:'',
                    des: '',
                    abilitys:[],
                    collCyc: null,
                    rptCyc:'',
                    emergencyCollCyc:'',
                    emergencyRptCyc:'',
                    enableCreateTask:'0',
                    enableSwitchPower:'0',
                    installDirection:'1',
                    enableGps: '0',
                    workEndTime: '',
                    lowElecRptCyc: '60',
                    lowElec: '',
                },
                rules: {
                    termVersion: { required: true, message: '请输入型号' },
                    name: {required: true, message: '请输入中文名'},
                    des: {required: true, message: '请输入描述'},
                    abilitys: {required: true, message: '请选择能力',trigger:'blur'},
                    collCyc: {required: true, message: '请输入采集周期'},
                    rptCyc: {required: true, message: '请输入上报周期',trigger:'blur'},
                    emergencyCollCyc: {required: true, message: '请输入紧急采集周期'},
                    emergencyRptCyc: {required: true, message: '请输入紧急上报周期'},
                    workStartTime: {required: true, message: '请选择工作开始时间',trigger:'blur'},
                    workEndTime: {required: true, message: '请选择工作结束时间',trigger:'blur'},
                    lowElecRptCyc: {required: true, message: '请输入低电上报周期',trigger:'blur'},
                    lowElec: {required: true, message: '请输入低电电压值',trigger:'blur'},
                },
            }
        },
        async created() {
            this.$http.get('/manage/ability/listAll').then(data=>{
                this.rolesCheck = data['data']['data'];
            });
            if(this.$route.params.id) {
                if(this.$store.state.editInfo.length == 0) {
                    this.$router.push('/equipment/portable/model');
                }else {
                    this.rule = this.$store.state.editInfo;
                    //角色回显
                    let temp = [];
                    for(let x of this.$store.state.editInfo.abilitys) {
                        temp.push(x.type);
                    }
                    this.rule.abilitys = temp;
                    //ext回显
                    this.$set(this.rule,'extid',this.rule.extVo.id);
                    this.$set(this.rule,'collCyc',this.rule.extVo.collCyc);
                    this.$set(this.rule,'emergencyCollCyc',this.rule.extVo.emergencyCollCyc);
                    this.$set(this.rule,'emergencyRptCyc',this.rule.extVo.emergencyRptCyc);
                    this.$set(this.rule,'lowElec',this.rule.extVo.lowElec);
                    this.$set(this.rule,'lowElecRptCyc',this.rule.extVo.lowElecRptCyc);
                    this.$set(this.rule,'rptCyc',this.rule.extVo.rptCyc);
                    this.$set(this.rule,'workEndTime',this.rule.extVo.workEndTime.substring(0,2) + ":" +this.rule.extVo.workEndTime.substring(2,4) + ":" + this.rule.extVo.workEndTime.substring(4,6));
                    this.$set(this.rule,'workStartTime',this.rule.extVo.workStartTime.substring(0,2) + ":" +this.rule.extVo.workStartTime.substring(2,4) + ":" + this.rule.extVo.workStartTime.substring(4,6));
                    this.$set(this.rule,'installDirection',this.rule.extVo.installDirection.toString());
                    //开关回显
                    this.$set(this.rule,'enableCreateTask',this.rule.extVo.enableCreateTask.toString());
                    this.$set(this.rule,'enableSwitchPower',this.rule.extVo.enableSwitchPower.toString());
                    this.$set(this.rule,'enableGps',this.rule.extVo.enableGps.toString());
                    delete this.rule.extVo;
                    this.checkList = temp;
                }
            }
        },
        methods:{
            submit() {
                this.$refs['forms'].validate(valid => {
                    if(valid) {
                        this.rule.ext = {
                            collCyc: Number(this.rule.collCyc),
                            emergencyCollCyc: Number(this.rule.emergencyCollCyc),
                            emergencyRptCyc: Number(this.rule.emergencyRptCyc),
                            enableCreateTask: Number(this.rule.enableCreateTask),
                            enableGps: Number(this.rule.enableGps),
                            enableSwitchPower: Number(this.rule.enableSwitchPower),
                            installDirection: Number(this.rule.installDirection),
                            lowElec: this.rule.lowElec,
                            lowElecRptCyc: Number(this.rule.lowElecRptCyc),
                            rptCyc: Number(this.rule.rptCyc),
                            workEndTime: this.rule.workEndTime.replace(/:/g,''),
                            workStartTime: this.rule.workStartTime.replace(/:/g,'')
                        }

                        //删除对象格式化后冗余数据
                        delete this.rule.collCyc;
                        delete this.rule.emergencyCollCyc;
                        delete this.rule.emergencyRptCyc;
                        delete this.rule.enableCreateTask;
                        delete this.rule.enableGps;
                        delete this.rule.enableSwitchPower;
                        delete this.rule.installDirection;
                        delete this.rule.lowElec;
                        delete this.rule.lowElecRptCyc;
                        delete this.rule.rptCyc;
                        delete this.rule.workEndTime;
                        delete this.rule.workStartTime;

                        if(this.rule.id == 0) {
                            delete this.rule.extid;
                            this.$http.post('/manage/term/add',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/portable/model');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }else {
                            this.rule.ext.id = this.rule.extid;
                            delete this.rule.extid;
                            this.$http.post('/manage/term/edit',this.rule).then(rs => {
                                if(rs.data.code == 0) {
                                    this.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                    this.$router.push('/equipment/portable/model');
                                }else {
                                    this.$message({
                                        message: rs.data.message,
                                        type: 'error'
                                    });
                                }
                            })
                        }
                    }
                });
            },
            block() {
                this.$router.push('/equipment/portable/model');
            },
            check() {
                this.rule.abilitys = this.checkList;
            }
        }
    }
</script>